import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["preserveAspectRatio", "viewBox"];
import React from 'react';

var Plane = function Plane(_ref) {
  var _ref$preserveAspectRa = _ref.preserveAspectRatio,
      preserveAspectRatio = _ref$preserveAspectRa === void 0 ? 'xMidYMid meet' : _ref$preserveAspectRa,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 24 24' : _ref$viewBox,
      unhandledProps = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({}, unhandledProps, {
    preserveAspectRatio: preserveAspectRatio,
    viewBox: viewBox
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.6523 11.8018C22.6431 10.707 21.1494 9.84424 19.3218 9.84424H15.5088C14.9893 9.84424 14.7944 9.75146 14.479 9.4082L8.18896 2.60791C7.98486 2.38525 7.74365 2.27393 7.47461 2.27393H6.27783C6.03662 2.27393 5.89746 2.49658 6.00879 2.74707L9.26514 9.83496L4.50586 10.3638L2.80811 7.33936C2.67822 7.10742 2.4834 7.00537 2.17725 7.00537H1.75977C1.50928 7.00537 1.34229 7.17236 1.34229 7.42285V16.1807C1.34229 16.4312 1.50928 16.5981 1.75977 16.5981H2.17725C2.4834 16.5981 2.67822 16.4961 2.80811 16.2642L4.50586 13.2305L9.26514 13.7686L6.00879 20.8564C5.89746 21.1069 6.03662 21.3296 6.27783 21.3296H7.47461C7.74365 21.3296 7.98486 21.209 8.18896 20.9956L14.479 14.1953C14.7944 13.8521 14.9893 13.7593 15.5088 13.7593H19.3218C21.1494 13.7593 22.6431 12.8872 22.6523 11.8018Z"
  })));
};

Plane.displayName = 'Plane';
export default Plane;